
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_b_5613_22005)"}},[_c('rect',{attrs:{"width":"50","height":"50","rx":"25","fill":"currentColor","fill-opacity":"0.28"}}),_c('path',{attrs:{"d":"M23.574 24.9991L30.999 17.5741L28.878 15.4531L19.332 24.9991L28.878 34.5451L30.999 32.4241L23.574 24.9991Z","fill":"currentColor"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_b_5613_22005","x":"-35","y":"-35","width":"120","height":"120","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"BackgroundImageFix","stdDeviation":"17.5"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur_5613_22005"}}),_c('feBlend',{attrs:{"mode":"normal","in":"SourceGraphic","in2":"effect1_backgroundBlur_5613_22005","result":"shape"}})])])])
          )
        }
      }
    